import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstants } from 'src/app/app-constants';
import { AppConfigService } from 'src/app/config/appconfig.service';
import { UserDetails } from 'src/app/models/user-details.model';
import { LoaderService } from 'src/app/services/loader.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-policy-found',
  templateUrl: './policy-found.component.html',
  styleUrls: ['./policy-found.component.scss']
})
export class PolicyFoundComponent {

  isPendingPolicy = false;
  userInfo: UserDetails;
  isGracePayment = false;

  constructor(private router: Router, private loaderService:LoaderService, private storageService:StorageService, private config: AppConfigService) { }

  ngOnInit(): void {
    this.loaderService.hideLoader();
    this.isGracePayment = this.config.getIsGracePayment();
    let isPendingPolicy = this.storageService.getIsPendingPolicy();
    if(!this.isGracePayment && isPendingPolicy == null){
      this.router.navigateByUrl('/home');
    } else{
      this.isPendingPolicy = isPendingPolicy;
    }
    let userInfo = this.storageService.getUserInfo();
    if(userInfo == null){
      this.onBack();
    } else{
      this.userInfo = userInfo;
    }
  }

  onNext() {
    this.router.navigateByUrl('/payment');
  }

  onBack() {
    if (this.isGracePayment) {
      this.router.navigate(['/policy-search'], { fragment: 'grace-payment' });
    } else {
      this.router.navigateByUrl('/policy-search');
    }
  }

  onCancel() {
    if (this.isGracePayment) {
      this.router.navigate(['/policy-search'], { fragment: 'grace-payment' });
    } else {
      window.location.href = ' https://www.nationwide.com/personal/member-services/pay-bill?utm_campaign=pl-sitelink&utm_medium=Search&utm_source=Bing&utm_content=All:PL:REP:NA:NA&utm_term=www%20nation&&msclkid=74591eadb69016dcc7837bfa31491e5d&gclid=74591eadb69016dcc7837bfa31491e5d&gclsrc=3p.ds';
    }
    
  }
}
